import React from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import { useAdaptedSettings, useStylesParams } from '../../../../hooks';
import { alignmentName } from '../../../../utils/alignment';
import { st, classes } from './List.st.css';

interface DisclaimerProps {
  maxWidthStyle: React.CSSProperties;
}

export const Disclaimer: React.FC<DisclaimerProps> = ({ maxWidthStyle }) => {
  const styles = useStyles();
  const stylesParams = useStylesParams();
  const settings = useAdaptedSettings();

  if (!styles.get(stylesParams.showDisclaimer)) {
    return null;
  }

  return (
    <div
      className={st(classes.disclaimer, {
        textAlignment: alignmentName(styles.get(stylesParams.disclaimerAlignment)),
      })}
      style={maxWidthStyle}
    >
      <p>{settings.get('disclaimerText')}</p>
    </div>
  );
};
